import { h } from 'preact';
import dlv from 'dlv';
import { Text } from 'preact-i18n';

export function getIframeStyles(embed) {
	let height = (dlv(embed, 'height') ? embed.height : 400);
	return `width: 100%; height:${height}px;`;
}

const validGenres = ['strategy', 'card', 'word', 'arcade'];
export function getRelatedProps(article) {
	let genres = dlv(article, 'metadata.genres', []),
		selectedGenre = 'word';

	genres.forEach((genre) => {
		if (validGenres.indexOf(genre) !== -1) selectedGenre = genre;
	});

	return {
		feed: `gen4_sc_games_${selectedGenre}`,
		title: `Other ${selectedGenre.charAt(0).toUpperCase() + selectedGenre.slice(1)} Games`,
		link: {
			url: `/browse/category/${selectedGenre}games`,
			label: <Text id="more" />
		},
		showDescription: true,
		attributionOverride: 'Play Now',
		imageCategory: 'entertainment',
		imageRole: 'w=300,h=169',
		rowCount: 2,
		columnCount: 3
	};
}

export function setLastGamePlayed(game) {
	const data = {
		id: game.metadata.canonical_id,
		title: game.title
	};
	localStorage.setItem('lastGamePlayed', JSON.stringify(data));
}

export function getLastGamePlayed() {
	const data = localStorage.getItem('lastGamePlayed');
	if (data) return JSON.parse(data);
	return null;
}
